import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Calculate the individual job data from the February CSV
const jobData = [
  {
    jobInfo: "244: Gloria & Tishan Norwood",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 5000.00,
    grossMarginPct: 0.6447,
    grossProfit: 3223.50,
    salesCommission: 500.00,
    salesManagerFee: 50.00,
    companyOH: 775.00,
    netProfit: 1898.50
  },
  {
    jobInfo: "242: Mary & Douglas Conover-Walker",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 15904.40,
    grossMarginPct: 0.5226,
    grossProfit: 8311.64,
    salesCommission: 1113.31,
    salesManagerFee: 159.04,
    companyOH: 2465.18,
    netProfit: 4574.11
  },
  {
    jobInfo: "241: Aaron Buckler",
    leadSource: "Facebook / Meta Ads",
    trade: "Windows & Doors",
    contractTotal: 11447.00,
    grossMarginPct: 0.4891,
    grossProfit: 5598.73,
    salesCommission: 457.88,
    salesManagerFee: 114.47,
    companyOH: 1774.29,
    netProfit: 3252.09
  },
  {
    jobInfo: "233: Nicole Fisher",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 2483.00,
    grossMarginPct: 0.6364,
    grossProfit: 1580.18,
    salesCommission: 248.30,
    salesManagerFee: 24.83,
    companyOH: 384.87,
    netProfit: 922.18
  },
  {
    jobInfo: "237: Betty & Timothy Moreland",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 24921.00,
    grossMarginPct: 0.5789,
    grossProfit: 14426.77,
    salesCommission: 1744.47,
    salesManagerFee: 249.21,
    companyOH: 3862.76,
    netProfit: 8570.33
  },
  {
    jobInfo: "224: Joyce Hooks",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 3821.00,
    grossMarginPct: 0.4200,
    grossProfit: 1604.82,
    salesCommission: 152.84,
    salesManagerFee: 38.21,
    companyOH: 592.26,
    netProfit: 821.51
  },
  {
    jobInfo: "239: Katherine (Katie) Riffle",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 10871.00,
    grossMarginPct: 0.4003,
    grossProfit: 4351.66,
    salesCommission: 434.84,
    salesManagerFee: 108.71,
    companyOH: 1685.01,
    netProfit: 2123.10
  },
  {
    jobInfo: "215: Jim & Samantha Paruszewski",
    leadSource: "Networx",
    trade: "Attic Insulation",
    contractTotal: 2992.00,
    grossMarginPct: 0.4800,
    grossProfit: 1436.16,
    salesCommission: 119.68,
    salesManagerFee: 29.92,
    companyOH: 463.76,
    netProfit: 822.80
  },
  {
    jobInfo: "223: Rob & Brenda Walper",
    leadSource: "Yard Sign",
    trade: "Roofing",
    contractTotal: 18872.00,
    grossMarginPct: 0.5419,
    grossProfit: 10226.74,
    salesCommission: 1321.04,
    salesManagerFee: 188.72,
    companyOH: 2925.16,
    netProfit: 5791.82
  },
  {
    jobInfo: "216: George (Kevin Gromley) Travez",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 7292.00,
    grossMarginPct: 0.4200,
    grossProfit: 3062.64,
    salesCommission: 291.68,
    salesManagerFee: 72.92,
    companyOH: 1130.26,
    netProfit: 1567.78
  },
  {
    jobInfo: "246: Anna Gwanyama",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 9000.00,
    grossMarginPct: 0.4230,
    grossProfit: 3807.00,
    salesCommission: 360.00,
    salesManagerFee: 90.00,
    companyOH: 1395.00,
    netProfit: 1962.00
  },
  {
    jobInfo: "252: Beverly Reeder",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 12950.00,
    grossMarginPct: 0.4025,
    grossProfit: 5212.38,
    salesCommission: 518.00,
    salesManagerFee: 129.50,
    companyOH: 2007.25,
    netProfit: 2557.63
  },
  {
    jobInfo: "247: Neil Greenberger",
    leadSource: "Networx",
    trade: "Windows & Doors",
    contractTotal: 4650.00,
    grossMarginPct: 0.4100,
    grossProfit: 1906.50,
    salesCommission: 186.00,
    salesManagerFee: 46.50,
    companyOH: 720.75,
    netProfit: 953.25
  },
  {
    jobInfo: "236: Steve & Cindy Williams",
    leadSource: "Facebook / Meta Ads",
    trade: "Windows & Doors",
    contractTotal: 41319.00,
    grossMarginPct: 0.4170,
    grossProfit: 17230.02,
    salesCommission: 1652.76,
    salesManagerFee: 413.19,
    companyOH: 6404.45,
    netProfit: 8759.62
  }
];

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalSalesCommissions = sum(jobData.map(job => job.salesCommission));
const totalManagerFees = sum(jobData.map(job => job.salesManagerFee));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));

// February 2025 data for the marketing report - based on user-provided values
export const februaryData: ReportData = {
  kpis: {
    // Sum of all ad spends from the February CSV
    adSpend: 24245.70,
    
    // Sum of all contract totals from the February Sales CSV - using the client-provided value
    totalSales: 171522.40,
    
    // Sum of all gross profits from the February Sales CSV - using the client-provided value
    grossProfit: 81978.73,
    
    // Sum of all sales commissions - using the client-provided value
    salesCommissions: 6948.04,
    
    // Sum of all manager fees - using the client-provided value
    managerFees: 1252.03,
    
    // Company overhead - using the client-provided value
    companyOH: 19406.53,
    
    // Net profit calculation using client values
    netProfit: 81978.73 - 6948.04 - 1252.03 - 19406.53 - 24245.70, // = 30126.43
    
    // Net profit as percentage of total sales
    netProfitPercent: (81978.73 - 6948.04 - 1252.03 - 19406.53 - 24245.70) / 171522.40,
    
    // Gross profit as percentage of total sales
    grossProfitPercent: 81978.73 / 171522.40
  },
  
  // Ad spend by lead source from February AdSpend CSV
  adSpendBySource: [
    { source: "Facebook / Meta Ads", spend: 3152.89 },
    { source: "Angi", spend: 2530.00 },
    { source: "Web to Lead Form (Roofing Calculator)", spend: 3740.00 },
    { source: "Thumbtack", spend: 3956.43 },
    { source: "Google Organic", spend: 3500.00 },
    { source: "HomeBuddy", spend: 2087.00 },
    { source: "Networx", spend: 1966.00 },
    { source: "Yelp", spend: 1364.43 },
    { source: "Google AdWords", spend: 1012.08 },
    { source: "Google LSA", spend: 349.07 },
    { source: "BBB", spend: 300.00 },
    { source: "Porch", spend: 287.80 },
    { source: "Guild Quality", spend: 0.00 },
    { source: "Contractor Appointment", spend: 0.00 },
    { source: "Lead2Performance", spend: 0.00 },
    { source: "Spring Connect", spend: 0.00 }
  ],
  
  // Sales by lead source - aggregated from February Sales CSV
  salesBySource: [
    { source: "Facebook / Meta Ads", totalSales: 52766.00, count: 2, grossProfit: 22828.75 },
    { source: "Yelp", totalSales: 33921.00, count: 2, grossProfit: 18233.77 },
    { source: "Thumbtack", totalSales: 29258.40, count: 3, grossProfit: 14243.48 },
    { source: "Referral", totalSales: 20242.00, count: 2, grossProfit: 8275.02 },
    { source: "Angi", totalSales: 8821.00, count: 2, grossProfit: 4828.32 },
    { source: "Networx", totalSales: 7642.00, count: 2, grossProfit: 3342.66 },
    { source: "Yard Sign", totalSales: 18872.00, count: 1, grossProfit: 10226.74 }
  ],
  
  // Sales by trade - aggregated from February Sales CSV
  salesByTrade: [
    { trade: "Windows & Doors", totalSales: 107241.40, count: 6, grossProfit: 50280.66 },
    { trade: "Roofing", totalSales: 49985.00, count: 4, grossProfit: 22853.42 },
    { trade: "Attic Insulation", totalSales: 11813.00, count: 3, grossProfit: 6264.48 },
    { trade: "Gutters", totalSales: 2483.00, count: 1, grossProfit: 1580.18 }
  ],
  
  // Individual job data from February Sales CSV
  jobData: jobData,
  period: {
    month: 2, // February
    year: 2025
  }
};